import { useSuspenseListPrompts } from '@repo/api-codegen';
import { observer } from 'mobx-react-lite';
import { memo, Suspense } from 'react';
import { AiChatController } from '../AiChat';
import { AiChatSkeleton } from '../AiChat/components/AiChatSkeleton';

const AiSideChatForObjectControllerInternal = observer(
	({
		startingPointEntityIdentifier,
	}: {
		startingPointEntityIdentifier: string;
	}) => {
		const { data, queryKey } = useSuspenseListPrompts({
			queryParams: {
				starting_point_entity_identifier: startingPointEntityIdentifier,
			},
		});

		return (
			<AiChatController
				isSidebar={true}
				initialId={data.results[0]?.id}
				startingPointEntityIdentifier={startingPointEntityIdentifier}
			/>
		);
	}
);

export const AiSideChatForObjectController = memo(
	(props: { startingPointEntityIdentifier: string }) => (
		<Suspense fallback={<AiChatSkeleton />}>
			<AiSideChatForObjectControllerInternal {...props} />
		</Suspense>
	)
);
